import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const getHeaders = () => {
  const token = localStorage.getItem('gm_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const api = {
  // Auth
  login: (data) => axios.post(`${API}/api/auth/login`, data),
  me: () => axios.get(`${API}/api/auth/me`, { headers: getHeaders() }),
  changePassword: (data) => axios.post(`${API}/api/auth/change-password`, data, { headers: getHeaders() }),
  adminResetPassword: (data) => axios.post(`${API}/api/auth/admin-reset-password`, data, { headers: getHeaders() }),
  forgotPassword: (data) => axios.post(`${API}/api/auth/forgot-password`, data),
  verifyOTP: (data) => axios.post(`${API}/api/auth/verify-otp`, data),

  // Leads
  getLeads: (params) => axios.get(`${API}/api/leads`, { headers: getHeaders(), params }),
  createLead: (data) => axios.post(`${API}/api/leads`, data, { headers: getHeaders() }),
  updateLead: (id, data) => axios.put(`${API}/api/leads/${id}`, data, { headers: getHeaders() }),
  deleteLead: (id) => axios.delete(`${API}/api/leads/${id}`, { headers: getHeaders() }),

  // Subscribers
  getSubscribers: (params) => axios.get(`${API}/api/subscribers`, { headers: getHeaders(), params }),
  createSubscriber: (data) => axios.post(`${API}/api/subscribers`, data, { headers: getHeaders() }),
  updateSubscriber: (id, data) => axios.put(`${API}/api/subscribers/${id}`, data, { headers: getHeaders() }),
  deleteSubscriber: (id) => axios.delete(`${API}/api/subscribers/${id}`, { headers: getHeaders() }),

  // Skips
  getSkips: (params) => axios.get(`${API}/api/skips`, { headers: getHeaders(), params }),
  createSkip: (data) => axios.post(`${API}/api/skips`, data, { headers: getHeaders() }),
  updateSkip: (id, data) => axios.put(`${API}/api/skips/${id}`, data, { headers: getHeaders() }),
  deleteSkip: (id) => axios.delete(`${API}/api/skips/${id}`, { headers: getHeaders() }),

  // OOT
  getOOT: (params) => axios.get(`${API}/api/oot`, { headers: getHeaders(), params }),
  createOOT: (data) => axios.post(`${API}/api/oot`, data, { headers: getHeaders() }),
  updateOOT: (id, data) => axios.put(`${API}/api/oot/${id}`, data, { headers: getHeaders() }),
  deleteOOT: (id) => axios.delete(`${API}/api/oot/${id}`, { headers: getHeaders() }),

  // Deliveries
  getTodayDeliveries: () => axios.get(`${API}/api/deliveries/today`, { headers: getHeaders() }),
  markDelivered: (data) => axios.post(`${API}/api/deliveries/mark`, data, { headers: getHeaders() }),
  getDeliveryHistory: (subId) => axios.get(`${API}/api/deliveries/history/${subId}`, { headers: getHeaders() }),
  getOptimizedRoute: (boyId) => axios.get(`${API}/api/deliveries/route`, { headers: getHeaders(), params: boyId ? { boyId } : {} }),
  saveRouteConfig: (data) => axios.post(`${API}/api/route-config`, data, { headers: getHeaders() }),
  getRouteConfig: (boyId) => axios.get(`${API}/api/route-config/${boyId}`, { headers: getHeaders() }),

  // Dashboard
  getDashboardStats: () => axios.get(`${API}/api/dashboard/stats`, { headers: getHeaders() }),

  // Delivery Boys
  getDeliveryBoys: () => axios.get(`${API}/api/delivery-boys`, { headers: getHeaders() }),
  createDeliveryBoy: (data) => axios.post(`${API}/api/delivery-boys`, data, { headers: getHeaders() }),
  updateDeliveryBoy: (id, data) => axios.put(`${API}/api/delivery-boys/${id}`, data, { headers: getHeaders() }),
  deleteDeliveryBoy: (id) => axios.delete(`${API}/api/delivery-boys/${id}`, { headers: getHeaders() }),

  // Plans
  getPlans: () => axios.get(`${API}/api/plans`, { headers: getHeaders() }),
  createPlan: (data) => axios.post(`${API}/api/plans`, data, { headers: getHeaders() }),
  updatePlan: (id, data) => axios.put(`${API}/api/plans/${id}`, data, { headers: getHeaders() }),
  deletePlan: (id) => axios.delete(`${API}/api/plans/${id}`, { headers: getHeaders() }),

  // Payments
  getPayments: (params) => axios.get(`${API}/api/payments`, { headers: getHeaders(), params }),
  createPayment: (data) => axios.post(`${API}/api/payments`, data, { headers: getHeaders() }),
  deletePayment: (id) => axios.delete(`${API}/api/payments/${id}`, { headers: getHeaders() }),
  getPaymentSummary: (subId) => axios.get(`${API}/api/payments/summary/${subId}`, { headers: getHeaders() }),

  // Alerts
  getRenewalAlerts: () => axios.get(`${API}/api/alerts/renewals`, { headers: getHeaders() }),

  // Auto-assign
  autoAssignDeliveryBoys: () => axios.post(`${API}/api/subscribers/auto-assign`, {}, { headers: getHeaders() }),

  // Apartments
  getApartments: () => axios.get(`${API}/api/apartments`, { headers: getHeaders() }),
  createApartment: (data) => axios.post(`${API}/api/apartments`, data, { headers: getHeaders() }),
  updateApartment: (id, data) => axios.put(`${API}/api/apartments/${id}`, data, { headers: getHeaders() }),
  deleteApartment: (id) => axios.delete(`${API}/api/apartments/${id}`, { headers: getHeaders() }),

  // Samples
  getSamples: (params) => axios.get(`${API}/api/samples`, { headers: getHeaders(), params }),
  createSample: (data) => axios.post(`${API}/api/samples`, data, { headers: getHeaders() }),
  updateSample: (id, data) => axios.put(`${API}/api/samples/${id}`, data, { headers: getHeaders() }),
  deleteSample: (id) => axios.delete(`${API}/api/samples/${id}`, { headers: getHeaders() }),
  convertSample: (id, data) => axios.post(`${API}/api/samples/${id}/convert`, data, { headers: getHeaders() }),

  // Next Day
  getNextDayDeliveries: () => axios.get(`${API}/api/deliveries/next-day`, { headers: getHeaders() }),

  // Import/Export
  importCustomers: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/api/import/customers`, fd, { headers: { ...getHeaders(), 'Content-Type': 'multipart/form-data' } });
  },
  exportCustomers: () => axios.get(`${API}/api/export/customers`, { headers: getHeaders() }),
};

export default api;
